import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { NoticeBoardService } from 'src/app/core/services/notice-board/notice-board.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-birthday-notice',
  templateUrl: './admin-birthday-notice.component.html',
  styleUrls: ['./admin-birthday-notice.component.scss']
})
export class AdminBirthdayNoticeComponent {

  file_base_url = environment.fileBaseUrl;
  university_details: any

  constructor(
      public router: Router,
      public dialogRef: MatDialogRef<AdminBirthdayNoticeComponent>,
      @Inject(MAT_DIALOG_DATA)
      public data,
      private _loaderService: LoaderService,
       private localStorage: LocalStorageService,
       private _noticeBoardService: NoticeBoardService,
        private _tosterService: ToasterService,
  ) {
    // console.log('data', data);
  }

  ngOnInit(): void {
    this.university_details = this.data;
    const cUser = this.localStorage.getUser();
      // this.viewNoticeAutoPopup();
      this.setUniversityImage();
      
  }


  setUniversityImage(): void {
        this.university_details.image = `${this.file_base_url}${this.university_details.imagePath}`;
        // console.log('this.university_details.image', this.university_details.image);
}

  close() {
      this.dialogRef.close();
  }

  markAsRead() {
    let id = this.data.noticeid;
    const payload = { 
       "isRead": "true"
     };
    this._loaderService.showLoader();
    this._noticeBoardService.getNoticeMarkAsRead(id, payload)
      .subscribe(
          (response) => {
            this._loaderService.hideLoader();
            // this._tosterService.showSuccess('Success', 'Marked as read successfully');
            this.dialogRef.close('marked');
          },
          (error) => {
              // handle error response
              // this._tosterService.showError('Error!', 'Something went wrong!');
          }
      );
      this._loaderService.hideLoader();
      this.dialogRef.close();
  }


//   viewNoticeAutoPopup() {
//     const payload = { id: this.data.id };
//     this._loaderService.showLoader();
//     this._noticeBoardService.getNoticeMarkAsRead(payload)
//       .subscribe(
//           (response) => {
//               // handle successful response
//           },
//           (error) => {
//               // handle error response
//           }
//       );
// }
}